import { render, staticRenderFns } from "./NavigationBarNotifications.vue?vue&type=template&id=21a2ba2f&scoped=true"
import script from "./NavigationBarNotifications.vue?vue&type=script&lang=js"
export * from "./NavigationBarNotifications.vue?vue&type=script&lang=js"
import style0 from "./NavigationBarNotifications.vue?vue&type=style&index=0&id=21a2ba2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a2ba2f",
  null
  
)

export default component.exports